import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input, // Import Input for search
} from "reactstrap";
// core components
import TablePagination from "views/components/TablePagination";
import defaultProfileImg from "../../assets/img/brand/goodybuddy_short.png"; // Placeholder profile image
import { filterItems } from "lib/helper"; // Import the filtering function
import * as XLSX from 'xlsx'; // Import XLSX for exporting to Excel
import ExportButton from "components/ExportButton";
import adminModel from "models/admin.model";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";

// Sample data for the sub-admins
const subAdminsData = [
  {
    _id: "1",
    name: "John Doe",
    mobile: "+1234567890",
    profilePicture: defaultProfileImg,
    email: "john@example.com",
    designation: "Manager",
  },
  {
    _id: "2",
    name: "Jane Smith",
    mobile: "+0987654321",
    profilePicture: defaultProfileImg,
    email: "jane@example.com",
    designation: "Supervisor",
  },
  {
    _id: "3",
    name: "Mark Johnson",
    mobile: "+1122334455",
    profilePicture: defaultProfileImg,
    email: "mark@example.com",
    designation: "Admin",
  },
  // Add more sub-admin entries as needed
];

const AllSubAdmins = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [subAdminsList, setSubAdminsList] = useState(subAdminsData);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const navigate = useNavigate();


  const getAllSubAdmins = async () => {
    setIsLoading(true);
    try{
      const res = await adminModel.getAllSubAdmins();
      setSubAdminsList(res.subAdmins);
      // console.log(res.subAdmins)
    }catch(error){
      console.log(error);
    }finally{
      setIsLoading(false);
    }
  }

  useEffect(() => {
    
    getAllSubAdmins();
  },[]);


  // Placeholder delete function
  const handleDelete = (id) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this sub-admin?", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          adminModel.deleteSubAdmin(id).then(res => {
            helper.sweetalert.toast("Sub-admin deleted successfully!");
            getAllSubAdmins();
          }).catch(error => console.log(error));
        }
      });
  };

  // Function to handle edit
  const handleUpdate = (id) => {
    navigate(`/admin/sub-admin/edit/${id}`);
  };

  // Function to export sub-admin data to Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(subAdminsList); // Convert subAdminsList to worksheet
    const workbook = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sub Admins"); // Append the worksheet to the workbook
    XLSX.writeFile(workbook, "sub_admins.xlsx"); // Export the workbook
  };

  const columnsConfig = [
    { label: "S.No", getValue: (item, index) => index + 1 },
    { label: "Name", getValue: (item) => item.name },
    { label: "Profile Picture", getValue: (item) => item.profilePicture, isImage: true },
    { label: "Mobile", getValue: (item) => item.mobile },
    { label: "Email", getValue: (item) => item.email },
    { label: "Designation", getValue: (item) => item.designation },
  ];


  // Filter sub-admins based on the search query
  const filteredSubAdminsList = filterItems(subAdminsList, searchQuery, ['name', 'mobile', 'email', 'designation']); // Update keys to search

  return (
    <Container className="pt-6" fluid>
      {!isLoading && (
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">All Admins</h3>
                  <div className="d-flex align-items-center">
                    <Input
                      type="text"
                      placeholder="Search by Buddy Name, Mobile, Experience Type..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: '300px', marginRight: '10px' }} // Optional: adjust width
                    />
                    <ExportButton data={filteredSubAdminsList} columnsConfig={columnsConfig} />
                  </div>
                </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Name (Mobile)</th>
                    <th scope="col">Profile Picture</th>
                    <th scope="col">Email Address</th>
                    <th scope="col">Designation</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSubAdminsList.slice((currentPage - 1) * perPage, currentPage * perPage).map((admin, index) => {
                    console.log(admin)
                    return (
                      <tr key={admin._id}>
                        <td>{((currentPage - 1) * perPage) + index + 1}</td>
                        <td>
                          {admin?.user?.firstName} {admin?.user?.lastName} <br />
                          <small>{admin?.user?.mobileNo}</small>
                        </td>
                        <td>
                          <img
                            src={admin?.user?.profileImage}
                            alt={admin?.user?.firstName}
                            style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                          />
                        </td>
                        <td>{admin?.user?.email}</td>
                        <td>{admin?.user?.type}</td>
                        <td>
                          <Button
                            color="warning"
                            size="sm"
                            className="mr-2"
                            onClick={() => handleUpdate(admin._id)}
                          >
                            <i class="fa-regular fa-pen-to-square"></i>
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(admin._id)}
                          >
                             <i class="fa-solid fa-trash"></i>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={Math.ceil(filteredSubAdminsList.length / perPage)} // Total number of pages based on filtered sub-admins
                  currentPage={currentPage}
                  pageUrl="/admin/sub-admins?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      )}
    </Container>
  );
};

export default AllSubAdmins;
